import React, { useState } from 'react';
import { v4 } from 'uuid';
import { Droppable } from 'react-beautiful-dnd';
import { BsPlus } from 'react-icons/bs';
import * as Styled from './style';
import DraggableComponent from '../DraggableComponent';
import TextField from '../TextField';

const isDuplicated = (elements, element, displayField) =>
  elements.some((element_) => element_[displayField] === element);

function CustomFormatForm({
  editing,
  displayField,
  context,
  placeholder,
  warning,
  elements,
  setElements,
}) {
  const [userInput, setUserInput] = useState('');
  const [componentError, setComponentError] = useState('');

  const addElement = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setComponentError('');

    if (isDuplicated(elements, userInput, displayField)) {
      setComponentError(`Duplicate ${warning} are not allowed`);
      return;
    }

    if (userInput !== '') {
      const object = {
        id: v4(),
        [displayField]: userInput,
      };
      setUserInput('');
      setElements([...elements, object]);
    }
  };
  const removeElement = (removeElement_) => {
    setElements([
      ...elements.filter((element) => element.id !== removeElement_.id),
    ]);
  };

  return (
    <Styled.CustomFormWrapper size={elements.length}>
      <Droppable isDropDisabled={!!editing} droppableId="mood-question">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {elements.map((element, index) =>
              editing ? (
                <Styled.RelativeContainer key={element.id || element}>
                  <span>{element[displayField] || element}</span>
                </Styled.RelativeContainer>
              ) : (
                <DraggableComponent
                  key={`draggable-component-${element.id || element}`}
                  element={element}
                  displayText={element[displayField]}
                  index={index}
                  removeElement={removeElement}
                />
              )
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {elements.length < 5 && elements.length >= 0 && !editing && (
        <Styled.RelativeContainer>
          <Styled.Field error={componentError}>
            <TextField
              id={`${context}label`}
              placeholder={placeholder}
              name={`${context}-input`}
              value={userInput}
              onChange={({ target }) => setUserInput(target.value)}
              onBlur={() =>
                isDuplicated(elements, userInput, displayField)
                  ? setComponentError(`Duplicate ${warning} are not allowed`)
                  : setComponentError('')
              }
              onKeyPress={(event) =>
                event.charCode === 13 ? addElement(event) : null
              }
            />
            {componentError !== '' ? (
              <Styled.ErrorInputMessage>
                {componentError}
              </Styled.ErrorInputMessage>
            ) : null}
            {userInput !== '' ? (
              <Styled.FloatButton forInput type="button" onClick={addElement}>
                <BsPlus />
              </Styled.FloatButton>
            ) : null}
          </Styled.Field>
        </Styled.RelativeContainer>
      )}
    </Styled.CustomFormWrapper>
  );
}

export default CustomFormatForm;
